import React from "react";
import "./care.css";
import { useNavigate } from "react-router-dom";
function CareDeliver() {
  const navigate = useNavigate();
  const handleExplore = () => {
    navigate("/explore-technology");
  };
  return (
    <div className="care-container">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mt-100">
            <p className="small-p">The WOW Platform – CarePulse</p>
            <h3>Care Delivered with Intelligence</h3>
            <p className="long-p">
              Our proprietary CarePulse platform matches your care needs with
              the right professional, offers real-time tracking, feedback
              integration, and family-access dashboards.
            </p>
            {/* <button onClick={handleExplore}>Explore Our Technology</button> */}
          </div>
          <div className="col-md-6 mt-40">
            <img
              src={require("../Assets/three-img.png")}
              alt="Doctors"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default CareDeliver;
